import React, { useEffect, useState } from 'react';
import { api } from '../../api.js';

export default function Memory({ project }) {
  const [m, setM] = useState(null);
  useEffect(() => { reload(); }, [project._id]);
  async function reload() { setM(await api(`/api/projects/${project._id}/memory`)); }

  async function addEntry(section, claim, source) {
    const body = { [section]: [{ claim, source }] };
    setM(await api(`/api/projects/${project._id}/memory`, { method: 'PATCH', body }));
  }

  async function deleteEntry(section, entryId) {
    setM(await api(`/api/projects/${project._id}/memory/${section}/${entryId}`, { method: 'DELETE' }));
  }

  if (!m) return null;
  return (
    <div className="memory">
      <header className="mem-h">
        <h2>What this project knows about you</h2>
        <p className="sub"><em>Inferred from your decisions and your direction. Editable.</em></p>
      </header>

      <div className="mem-grid">
        <Section
          title="Inferred preferences"
          entries={m.preferences}
          section="preferences"
          onAdd={(c, s) => addEntry('preferences', c, s)}
          onDelete={(id) => deleteEntry('preferences', id)}
        />
        <Section
          title="Standing instructions"
          entries={m.standing}
          section="standing"
          onAdd={(c, s) => addEntry('standing', c, s)}
          onDelete={(id) => deleteEntry('standing', id)}
        />
      </div>

      {(m.blanks || []).length > 0 && (
        <section className="mem-blanks">
          <h3>What the room doesn't know about you yet</h3>
          <ul>{m.blanks.map((b, i) => <li key={i}><em>{b}</em></li>)}</ul>
        </section>
      )}
    </div>
  );
}

function Section({ title, entries, section, onAdd, onDelete }) {
  const [adding, setAdding] = useState(false);
  return (
    <section className="mem-col">
      <h3>{title}</h3>
      <ul>
        {entries.map(e => (
          <li key={e._id} className="mem-item">
            <em>{e.claim}</em>
            {e.source && <span className="src">{e.source}</span>}
            <button
              type="button"
              className="btn ghost mem-del"
              onClick={() => onDelete(e._id)}
              title="Remove this entry"
            >×</button>
          </li>
        ))}
      </ul>
      {adding
        ? <AddForm onCancel={() => setAdding(false)} onSubmit={(c, s) => { onAdd(c, s); setAdding(false); }} />
        : <button type="button" className="btn ghost" onClick={() => setAdding(true)}>+ Add {section === 'preferences' ? 'preference' : 'instruction'}</button>}
    </section>
  );
}

function AddForm({ onSubmit, onCancel }) {
  const [claim, setClaim] = useState('');
  const [source, setSource] = useState('');
  return (
    <form className="mem-add" onSubmit={(e) => { e.preventDefault(); if (claim.trim()) onSubmit(claim.trim(), source.trim()); }}>
      <input value={claim}  onChange={e => setClaim(e.target.value)}  placeholder="The claim (e.g., prefers chamber scale)" autoFocus />
      <input value={source} onChange={e => setSource(e.target.value)} placeholder="Source (e.g., decision #3 — optional)" />
      <div style={{ display: 'flex', gap: 6 }}>
        <button type="submit" className="btn accent" disabled={!claim.trim()}>Save</button>
        <button type="button" className="btn ghost" onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
}
